import React, { useState } from 'react'
import InfoModal from '../modal/info-modal'
import HelpSVG from '../../assets/svg/help.svg'
import {
  useBulkUpdateRequest,
  useGetEmployeeRequest,
} from '../../redux/employees/hook'
import DataTable from '../datatable'
import Button from '../button'
import { PAGINATION_DEFAULT, requestStatusConfig } from '../../utils/constants'
import { useHistory } from 'react-router-dom'

const EmployeeRequests = () => {
  const [showInfoModal, setShowInfoModal] = useState(false)
  const history = useHistory()

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })

  const { refetch: refetchProfiles, data: profileRequest } =
    useGetEmployeeRequest(
      pagination?.limit,
      pagination?.page,
      pagination?.statusFilter,
      pagination?.search
    )
  const { mutateAsync: bulkUpdateRequest } = useBulkUpdateRequest()

  const tableConfig = {
    headers: [
      'Employee Name',
      'Phone Number',
      'Email',
      'PFA Name',
      'Bank name',
      'Account Number',
      'Status',
    ],
    keys: [
      'employeeName',
      'mobile',
      'email',
      'pfa_name',
      'bank_name',

      'account_number',
      'status',
    ],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Mobile',
        key: 'phone',
      },
    },
  }

  const actionConfig = [
    {
      name: 'View',
      color: 'orange',
      action: (id) => {
        let index = profileRequest.data.findIndex((item) => item.id === id)
        history.push('/employees-request/view/' + profileRequest.data[index].id)
      },
    },
  ]

  // const bulkActionConfig = [
  //   {
  //     label: 'Approve',
  //     value: 'active',
  //     action: (data) => {

  //     },
  //   },
  //   {
  //     label: 'Decline',
  //     value: 'active',
  //     action: (data) => {

  //     },
  //   },
  // ]

  const bulkActionConfig = [
    {
      label: 'Approve',
      value: 'approve',
      action: async (data) => {
        let selectedIds = data.split(',')
        let result = []

        selectedIds.forEach((id) => {
          let index = profileRequest.data.findIndex((item) => item.id == id)
          if (index !== -1) {
            result.push({
              id: profileRequest.data[index].id.toString(),
              action: '1',
            })
          }
        })

        if (!result.length) return

        try {
          await bulkUpdateRequest({ data: result })
          refetchProfiles()
        } catch (error) {
          console.error('Bulk approval failed:', error)
        }
      },
    },
    {
      label: 'Decline',
      value: 'decline',
      action: async (data) => {
        let selectedIds = data.split(',')
        let result = []

        selectedIds.forEach((id) => {
          let index = profileRequest.data.findIndex((item) => item.id == id)
          if (index !== -1) {
            result.push({
              id: profileRequest.data[index].id.toString(),
              action: '2',
            })
          }
        })

        if (!result.length) return

        try {
          await bulkUpdateRequest({ data: result })
          refetchProfiles()
        } catch (error) {
          console.error('Bulk decline failed:', error)
        }
      },
    },
  ]

  return (
    <main className='flex flex-col mt-4'>
      <div className='flex items-center justify-end w-full'>
        <img
          className='animate-bounce cursor-pointer hover:animate-none hover:scale-110 duration-300'
          onClick={() => {
            setShowInfoModal(true)
          }}
          src={HelpSVG}
          alt='help!'
          width={'40px'}
          height={'10px'}
        />
      </div>
      {showInfoModal ? (
        <InfoModal
          isOpen={showInfoModal}
          type={'bonus'}
          closeModal={() => setShowInfoModal(false)}
        />
      ) : null}
      <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
        <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full'>
          Employee Requests
        </div>
        <div className='flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[60%] w-full'>
          <div className='md:w-fit w-[100%]'>
            <Button
              text='Refresh'
              type='button'
              theme='primary'
              className='flex gap-2 !h-[35px] md:w-fit w-full p-2 '
              textClass={'!text-[11px]'}
              leftIcon={'change'}
              onClick={() => {
                refetch()
              }}
            />
          </div>
        </div>
      </div>

      <hr className='divider mt-2 mb-1' />
      <DataTable
        data={profileRequest}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        bulkActionConfig={bulkActionConfig}
        statusConfig={requestStatusConfig}
        filterByStatus={true}
        updatePagination={(data) => setPagination(data)}
        searchData={true}
        computedActions={true}
        // noCheck={true}
      />
    </main>
  )
}

export default EmployeeRequests
